import axios from "axios";
import API_URL from "@/utils/api";

const API = API_URL;

class ConfigService {
    constructor() {
        this.config = null;
        this.callbacks = [];
        this.isLoading = false;
    }

    async loadConfig() {
        if (this.config) return this.config;

        this.isLoading = true;
        try {
            const response = await axios.get(`${API}/config`);
            this.config = response.data;

            // Fallback defaults
            if (!this.config.name) this.config.name = "ZTAC TACOS";
            if (!this.config.logo) this.config.logo = "https://customer-assets.emergentagent.com/job_taco-tracker-4/artifacts/49jtitvp_2NARANJAlogo%20ordenado%20definitivo.png";

            return this.config;
        } catch (error) {
            console.error("Failed to load config", error);
            // Return safe fallback
            return {
                name: "ZTAC TACOS",
                logo: "https://customer-assets.emergentagent.com/job_taco-tracker-4/artifacts/49jtitvp_2NARANJAlogo%20ordenado%20definitivo.png",
                primary_color: "#FF4757"
            };
        } finally {
            this.isLoading = false;
        }
    }

    getConfig() {
        return this.config || {
            name: "ZTAC TACOS",
            logo: "https://customer-assets.emergentagent.com/job_taco-tracker-4/artifacts/49jtitvp_2NARANJAlogo%20ordenado%20definitivo.png"
        };
    }
}

export const configService = new ConfigService();
